<ion-content>

  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData?.dark_logo[0]"></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1><b>{{'My Accommodations' | translate}}</b></h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="accomServ.visits">

      <ion-col size="12">
        <ion-card class="add-card" (click)="modalServ.newAccomodation()">
          <!-- <img src="assets/img/logo-outline.svg"> -->

          <ion-icon name="add"></ion-icon>
          <ion-text color="primary">
            <small><b>{{'Add New Accommodation' | translate}}</b></small>
          </ion-text>
        </ion-card>
      </ion-col>

      <ion-col size="12" *ngFor="let visit of accomServ.visits">
        <ion-card>
          <!-- <img src="assets/img/logo-outline.svg"> -->

          <ion-card-header>
            <ion-card-title>{{visit.room_no || visit.name}}</ion-card-title>
            <ion-card-subtitle color="primary">{{visit.start_date | date:'dd/MM/yyyy'}} - {{visit.end_date |
              date:'dd/MM/yyyy'}}
            </ion-card-subtitle>

            <ion-text color="dark">
              {{'Nights' | translate}}: <b>{{visit.night}}</b> <br>
              <ng-container *ngIf="authServ.profile.loyalty_info.points_earned">
                {{'Points Earned' | translate}}: <b>{{visit.point}}</b>
              </ng-container>
            </ion-text>
          </ion-card-header>

        </ion-card>
      </ion-col>
    </ion-row>

  </ion-grid>
</ion-content>
